﻿/**
 * Overlay da LP RIMOWA na Vitrinni.
 * Corta outlet-metz.es. Checkout vai à White da pool (RIMOW_ACTIVE_SHOP / country da pool).
 * Sem dest na White: não cobra na vitrine.
 */
(function () {
  var SIZE_FROM_HANDLE = {
    'rimowa-classic-cabin-s': 'Cabin S',
    'rimowa-classic-cabin': 'Cabin',
    'rimowa-classic-check-in-m': 'Check-In M',
    'rimowa-classic-check-in-l': 'Check-In L',
    'rimowa-classic-trunk': 'Trunk'
  };

  function applyVids() {
    var map = window.RIMOW_MAP;
    if (!map || typeof VARIANTS === 'undefined') return;
    Object.keys(map).forEach(function (size) {
      Object.keys(map[size] || {}).forEach(function (color) {
        if (!VARIANTS[size] || !VARIANTS[size][color]) return;
        var row = map[size][color];
        VARIANTS[size][color].vid = row.vid;
        VARIANTS[size][color].sku = row.sku;
        VARIANTS[size][color].checkout = '/cart/' + row.vid + ':1';
      });
    });
  }

  function readDrState() {
    var scripts = document.querySelectorAll('script[data-dr-injected="true"]');
    for (var i = 0; i < scripts.length; i++) {
      var t = scripts[i].textContent || '';
      var shop = (t.match(/shopDomain:\s*'([^']+)'/) || [])[1];
      var mapRaw = (t.match(/MAP_STANDARD:\s*(\{[\s\S]*?\})/) || [])[1];
      if (!shop || !mapRaw) continue;
      try {
        return { shopDomain: shop, MAP_STANDARD: JSON.parse(mapRaw) };
      } catch (e) {}
    }
    return null;
  }

  function cookieGet(name) {
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return ''; }
  }

  function attrQuery(extra) {
    var stored = {};
    try { stored = JSON.parse(localStorage.getItem('dr_attr') || '{}'); } catch (e) {}
    try {
      var p = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid', 'ttclid', 'sck', 'xcod'].forEach(function (k) {
        var v = p.get(k); if (v) stored[k] = v;
      });
    } catch (e) {}
    var fbp = cookieGet('_fbp');
    if (fbp) { stored._fbp = fbp; stored.fbp = fbp; }
    var fbcCookie = cookieGet('_fbc');
    if (fbcCookie) { stored.fbc = fbcCookie; }
    else if (stored.fbclid) { stored.fbc = 'fb.1.' + Date.now() + '.' + stored.fbclid; }
    if (extra) Object.keys(extra).forEach(function (k) { if (extra[k]) stored[k] = extra[k]; });
    try {
      // fbclid novo diferente do que esta no fbc guardado -> refazer fbc com o clique novo
      if (stored.fbclid && stored.fbc) {
        var m = String(stored.fbc).match(/fb\.1\.\d+\.(.+)/);
        var fbcClick = m ? m[1] : '';
        if (fbcClick && fbcClick !== stored.fbclid) {
          stored.fbc = 'fb.1.' + Date.now() + '.' + stored.fbclid;
        }
      }
      localStorage.setItem('dr_attr', JSON.stringify(stored));
    } catch (e) {}
    var parts = [];
    Object.keys(stored).forEach(function (k) {
      if (!stored[k]) return;
      parts.push(k + '=' + encodeURIComponent(stored[k]));
      parts.push('attributes[' + k + ']=' + encodeURIComponent(stored[k]));
    });
    return parts.join('&');
  }

  var DR_ALLOWED = { 'outlet-cabina.com': 1, 'cabina-outlet.com': 1 };
  var DR_HOST_FIX = { 'outletcabina.es': 'outlet-cabina.com', 'www.outletcabina.es': 'outlet-cabina.com', 'outletcabina.de': 'outlet-cabina.com', 'www.outletcabina.de': 'outlet-cabina.com', 'outlet-cabina.es': 'cabina-outlet.com', 'www.outlet-cabina.es': 'cabina-outlet.com', 'outlet-cabina.de': 'cabina-outlet.com', 'www.outlet-cabina.de': 'cabina-outlet.com', 'www.outlet-cabina.com': 'outlet-cabina.com', 'www.cabina-outlet.com': 'cabina-outlet.com', 'delurs.online': 'outlet-cabina.com', 'delurt.store': 'cabina-outlet.com', 'edelkofferwelt.de': 'outlet-cabina.com', 'edelkofferhaus.de': 'cabina-outlet.com', 'wwv336-zq.myshopify.com': 'outlet-cabina.com', 'h19yvc-sy.myshopify.com': 'cabina-outlet.com', 'delurtwo.shop': 'outlet-cabina.com' };
  function drFixHost(shop) {
    shop = String(shop || '').replace(/^https?:\/\//, '').split('/')[0].toLowerCase();
    return DR_HOST_FIX[shop] || shop;
  }
  (function scrubPool() {
    var pool = window.RIMOW_POOL;
    if (!pool) return;
    Object.keys(pool).forEach(function (k) {
      var nk = drFixHost(k);
      if (nk !== k) {
        if (!pool[nk]) pool[nk] = pool[k];
        try { delete pool[k]; } catch (e) { pool[k] = undefined; }
      }
    });
  })();
  function poolActiveShop() {
    var s = window.RIMOW_ACTIVE_SHOP;
    if (typeof s !== 'string' || !s) return '';
    s = s.replace(/^https?:\/\//, '').replace(/\/.*$/, '').toLowerCase();
    s = drFixHost(s);
    return s;
  }
  function poolCountry() {
    return 'US';
  }
  function mapWhite(vid) {
    vid = String(vid);
    var state = readDrState();
    var pool = window.RIMOW_POOL || {};
    var poolShop = poolActiveShop();
    var shop = poolShop || drFixHost((state && state.shopDomain) || (window.RIMOW_FALLBACK_SHOP || 'outlet-cabina.com'));
    if (!poolShop && !DR_ALLOWED[shop]) shop = drFixHost(window.RIMOW_FALLBACK_SHOP || 'outlet-cabina.com');
    var dest = (pool[shop] && pool[shop][vid]) ? String(pool[shop][vid]) : null;
    if (!dest && state && state.MAP_STANDARD && state.MAP_STANDARD[vid]) {
      var drShop = drFixHost(state.shopDomain || '');
      if (!poolShop || drShop === shop) dest = String(state.MAP_STANDARD[vid]);
    }
    if (!dest) {
      var shops = Object.keys(pool);
      for (var i = 0; i < shops.length; i++) {
        var sk = drFixHost(shops[i]);
        if (!DR_ALLOWED[sk] && sk !== poolShop) continue;
        if (pool[shops[i]] && pool[shops[i]][vid]) { dest = String(pool[shops[i]][vid]); shop = sk; break; }
      }
    }
    shop = drFixHost(shop);
    if (!DR_ALLOWED[shop]) shop = drFixHost(window.RIMOW_FALLBACK_SHOP || 'outlet-cabina.com');
    return { shop: shop, dest: dest };
  }

  function currentQty() {
    var sel = document.querySelector('.quantity-selector');
    return parseInt(sel && sel.value, 10) || 1;
  }

  function goToWhite(lines) {
    if (!lines || !lines.length) {
      alert('Checkout is being prepared. Please try again shortly.');
      return;
    }
    var shop = null;
    var parts = [];
    var ids = [];
    var totalQty = 0;
    var totalVal = 0;
    lines.forEach(function (ln) {
      var mapped = mapWhite(String(ln.vid));
      if (!mapped.dest) return;
      if (!shop) shop = mapped.shop;
      var q = parseInt(ln.qty, 10) || 1;
      parts.push(mapped.dest + ':' + q);
      ids.push(String(mapped.dest));
      totalQty += q;
      totalVal += (parseFloat(ln.price) || 0) * q;
    });
    if (!shop || !parts.length) {
      alert('Checkout is being prepared. Please try again shortly.');
      return;
    }
    /* InitiateCheckout: removido do browser, wetracked manda server-side (evitava dupla contagem no Meta) */
    var qs = attrQuery({ event_id: 'invelo.tt.ic.' + ids[0] });
    var cc = poolCountry();
    var url = 'https://' + shop + '/en-us/cart/' + parts.join(',') + '?country=US&localization[country]=US&locale=en';
    if (qs) url += '&' + qs;
    window.location.href = url;
  }

  window.goToCheckout = function () {
    if (typeof getVariant !== 'function') return;
    var v = getVariant(activeSize, activeColor);
    if (!v || !v.vid) {
      alert('Checkout is being prepared. Please try again shortly.');
      return;
    }
    goToWhite([{ vid: v.vid, qty: currentQty(), price: parseFloat(v.price) || 0, sku: v.sku }]);
  };

  window.checkoutFromCart = function () {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var lines = (c.items || []).map(function (it) {
          return {
            vid: it.variant_id || it.id,
            qty: it.quantity,
            price: (it.price || 0) / 100,
            sku: it.sku
          };
        });
        if (!lines.length) {
          window.goToCheckout();
          return;
        }
        goToWhite(lines);
      })
      .catch(function () { window.goToCheckout(); });
  };

  window.addAlCarrito = function () {
    if (typeof getVariant !== 'function') return;
    var v = getVariant(activeSize, activeColor);
    if (!v || !v.vid) return;
    var qtd = currentQty();
    var b = document.getElementById('add-btn');
    if (b) { b.disabled = true; b.textContent = 'Adding...'; }
    window.openCart({ skipLoad: true });
    var cartBody = document.getElementById('rmw-crt-body');
    var cartFoot = document.getElementById('rmw-crt-foot');
    if (cartBody) cartBody.innerHTML = '<div class="crt-vazio">Adding to cart...</div>';
    if (cartFoot) cartFoot.style.display = 'none';
    var added = false;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(v.vid, 10), quantity: qtd }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); added = true; return fetch('/cart.js', { credentials: 'same-origin' }); })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (c) {
        var total = c.item_count || qtd;
        var needsRefresh = c.total_discount > 0 || (typeof bundleFor === 'function' && !!bundleFor(total));
        var update = (typeof crtBundle === 'function') ? crtBundle(total, c) : null;
        return Promise.resolve(update).then(function () {
          if (needsRefresh) window.crtCarregar();
          else renderCart(c);
        });
      })
      .catch(function () {
        if (added) window.crtCarregar();
        else if (cartBody) cartBody.innerHTML = '<div class="crt-vazio">The suitcase could not be added. Please try again.</div>';
      })
      .then(function () { if (b) { b.disabled = false; b.textContent = 'Add to cart'; } });
  };

  function money(cents) {
    try {
      return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function killHorizonCart() {
    var host = document.getElementById('cart-drawer');
    if (host) {
      try { if (typeof host.close === 'function') host.close(); } catch (e) {}
      host.remove();
    }
    document.querySelectorAll('dialog.theme-drawer__dialog[open]').forEach(function (d) {
      try { if (typeof d.close === 'function') d.close(); } catch (e) {}
      d.removeAttribute('open');
    });
  }
  window.killHorizonCart = killHorizonCart;

  function parkCart() {
    var ov = document.getElementById('rmw-crt-ov') || document.getElementById('crt-ov');
    if (!ov) return ov;
    ov.id = 'rmw-crt-ov';
    var body = ov.querySelector('#crt-body, #rmw-crt-body');
    var foot = ov.querySelector('#crt-foot, #rmw-crt-foot');
    var ir = ov.querySelector('#crt-ir, #rmw-crt-ir');
    var resumo = ov.querySelector('#crt-resumo, #rmw-crt-resumo');
    if (body) body.id = 'rmw-crt-body';
    if (foot) foot.id = 'rmw-crt-foot';
    if (ir) ir.id = 'rmw-crt-ir';
    if (resumo) resumo.id = 'rmw-crt-resumo';
    if (ov.parentNode !== document.body) document.body.appendChild(ov);
    return ov;
  }

  function renderCart(c) {
    var body = document.getElementById('rmw-crt-body') || document.getElementById('crt-body');
    var foot = document.getElementById('rmw-crt-foot') || document.getElementById('crt-foot');
    var resumo = document.getElementById('rmw-crt-resumo') || document.getElementById('crt-resumo');
    if (!body) return;
    if (!c || !c.items || !c.items.length) {
      body.innerHTML = '<div class="crt-vazio">Your cart is empty.<br>Choose your suitcase and click <strong>Buy now</strong>.</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    var html = '';
    c.items.forEach(function (it) {
      var key = it.key || String(it.id);
      var oldPrice = typeof crtPreisAlt === 'function' ? crtPreisAlt(it) : 0;
      html += '<div class="crt-item">' +
        '<img class="crt-item__img" src="' + (it.image || '') + '" alt="">' +
        '<div class="crt-item__b">' +
          '<div class="crt-item__t">' + (it.product_title || it.title || '') + '</div>' +
          '<div class="crt-qtd">' +
            '<button class="crt-qtd__b" type="button" data-rmw-qty="' + (it.quantity - 1) + '" data-rmw-key="' + key.replace(/"/g, '') + '"' + (it.quantity <= 1 ? ' disabled' : '') + '>\u2212</button>' +
            '<span class="crt-qtd__n">' + it.quantity + '</span>' +
            '<button class="crt-qtd__b" type="button" data-rmw-qty="' + (it.quantity + 1) + '" data-rmw-key="' + key.replace(/"/g, '') + '">+</button>' +
          '</div>' +
          '<button class="crt-item__r" type="button" data-rmw-qty="0" data-rmw-key="' + key.replace(/"/g, '') + '">Remove</button>' +
        '</div>' +
        '<div class="crt-item__p">' + money(it.line_price) +
          (oldPrice ? '<span class="crt-item__pold">' + money(oldPrice) + '</span>' : '') + '</div>' +
      '</div>';
    });
    var sug = '';
    try { if (typeof crtSugestoes === 'function') sug = crtSugestoes(c) || ''; } catch (e) {}
    body.innerHTML = '<div class="crt-items-label">Your selection</div>' + html + sug;
    if (foot) foot.style.display = '';
    if (resumo) {
      resumo.innerHTML = '<div class="crt-tot"><span class="crt-tot__l">Total</span><span class="crt-tot__v">' + money(c.total_price) + '</span></div>';
    }
  }

  window.crtCarregar = function () {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  };

  window.crtCambiar = function (key, qtd) {
    if (!key) return;
    var body = document.getElementById('rmw-crt-body') || document.getElementById('crt-body');
    if (body) body.style.opacity = '0.5';
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qtd })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (body) body.style.opacity = '';
        if (c && c.items) renderCart(c);
        else window.crtCarregar();
        killHorizonCart();
      })
      .catch(function () {
        if (body) body.style.opacity = '';
        window.crtCarregar();
      });
  };

  window.crtQuitar = function (key) { window.crtCambiar(key, 0); };

  window.openCart = function (options) {
    parkCart();
    var ov = document.getElementById('rmw-crt-ov');
    if (ov) ov.classList.add('open');
    document.body.style.overflow = 'hidden';
    if (!options || !options.skipLoad) window.crtCarregar();
    killHorizonCart();
  };

  window.closeCart = function () {
    var ov = document.getElementById('rmw-crt-ov');
    if (ov) ov.classList.remove('open');
    document.body.style.overflow = '';
  };

  document.addEventListener('DOMContentLoaded', function () {
    applyVids();
    try {
      if (window.DR_STATE && window.DR_STATE.shopDomain) {
        var poolShop = poolActiveShop();
        var drFixed = poolShop || drFixHost(window.DR_STATE.shopDomain);
        if (!poolShop && !DR_ALLOWED[drFixed]) drFixed = drFixHost(window.RIMOW_FALLBACK_SHOP || 'outlet-cabina.com');
        if (drFixed !== window.DR_STATE.shopDomain) {
          window.DR_STATE.shopDomain = drFixed;
          if (window.DR_STATE.checkoutUrl) window.DR_STATE.checkoutUrl = window.DR_STATE.checkoutUrl.replace(/https?:\/\/[^\/]+/, 'https://' + drFixed);
        }
      }
    } catch (e) {}
    var handle = (window.RIMOW_SHOPIFY && window.RIMOW_SHOPIFY.handle) || '';
    var size = SIZE_FROM_HANDLE[handle];
    if (size && typeof selectSize === 'function') selectSize(size);

    parkCart();
    var ov = document.getElementById('rmw-crt-ov');
    if (ov) {
      ov.addEventListener('click', function (e) {
        if (e.target === ov) { window.closeCart(); return; }
        var btn = e.target.closest('[data-rmw-key]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        window.crtCambiar(btn.getAttribute('data-rmw-key'), parseInt(btn.getAttribute('data-rmw-qty'), 10));
      }, true);
    }
    var ir = document.getElementById('rmw-crt-ir');
    if (ir) {
      ir.setAttribute('href', '#');
      ir.addEventListener('click', function (e) {
        e.preventDefault();
        window.checkoutFromCart();
      });
    }

    var native = document.getElementById('cart-drawer');
    if (native) native.remove();
    document.querySelectorAll('cart-drawer-component').forEach(function (el) { el.remove(); });
    killHorizonCart();
    try { document.documentElement.style.setProperty('view-transition-name', 'none'); } catch (e) {}
  });
})();

